import React from 'react';
import { useCandidateProfile } from 'candidate_profile_redesign/store';
import {
  useFetchFraudResolvedReasons,
  useResolveFraudReport,
} from 'candidate_profile_redesign/shared/queries/useFraudReport';
import ResolveFraudReportModal from 'fraud/components/resolve_fraud_report_modal';

const ResolveReportModal = () => {
  const {
    actions: { useGlobalModal },
  } = useCandidateProfile();

  const { isOpen, closeModal } = useGlobalModal('resolveFraudReportModal');
  const { data: resolvedReasons = [] } = useFetchFraudResolvedReasons({
    enabled: isOpen,
  });
  const { mutate: resolveFraudReport, isPending } = useResolveFraudReport();

  return (
    <ResolveFraudReportModal
      isOpen={isOpen}
      closeModal={closeModal}
      onResolve={resolveFraudReport}
      resolvedReasons={resolvedReasons}
      isPending={isPending}
    />
  );
};

export default ResolveReportModal;
